export const MAX_ROWS_TO_RENDER = 2000;
